<template>
	<div>
		<el-dialog title="新建关联达人" :visible.sync="dialogVisible" width="520px" :before-close="handleClose" :append-to-body="true">
			<el-alert title="达人信息的更新可能会延迟，请耐心等待" type="warning" show-icon :closable="false" />
			<el-form class="mt-16" :model="form" :rules="rules" ref="ruleForm" label-width="82px">
				<div class="label">团长信息</div>
				<el-form-item label="平台">
					<div class="flex flex-align-center">
						<div class="i-kuaishou"></div>
						<span class="yx-color-text-primary ml-4">{{ platformName }}</span>
					</div>
				</el-form-item>
				<el-form-item label="关联团长">
					<div>{{ institutionName }}</div>
				</el-form-item>
				<div class="label">基本信息</div>
				<el-form-item :label="`${platformName}ID/${platformName}号`" prop="anchorAccount" label-width="120px">
					<el-input v-model="form.anchorAccount" placeholder="请输入" maxlength="20" />
					<p class="font-h6-regular yx-color-text-placeholder">快手ID为纯数字，快手号仅支持8-20个字母、数字、下划线或减号，必须以字母开头</p>
				</el-form-item>
				<el-form-item label="达人昵称" prop="anchorName" label-width="120px">
					<el-input v-model="form.anchorName" placeholder="请输入达人昵称" />
				</el-form-item>
				<el-form-item label="备注" label-width="120px">
					<el-input v-model="form.remark" placeholder="请输入" />
				</el-form-item>
			</el-form>
			<span slot="footer">
				<el-button type="primary" @click="submit">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';
import { institutionAddAnchorKs } from '@/api/secondColonelManage';
import { PLATFORM_KS } from '@/utils/dataMap';
export default {
	name: 'addTalentDialog',
	computed: {
		platformName() {
			return PLATFORM_KS.label;
		},
	},
	data() {
		return {
			dialogVisible: false,
			institutionName: '',
			form: {
				teamInstitutionId: '',
				anchorAccount: '',
				anchorName: '',
				remark: '',
			},
			rules: {
				anchorAccount: { required: true, message: `请输入${PLATFORM_KS.label}号/ID`, trigger: 'blur' },
				anchorName: { required: true, message: '请输入达人昵称', trigger: 'blur' },
			},
		};
	},
	methods: {
		show(teamInstitutionId, institutionName) {
			this.institutionName = institutionName;
			this.form.teamInstitutionId = teamInstitutionId;
			this.dialogVisible = true;
		},
		handleClose() {
			this.institutionName = '';
			this.form = {
				teamInstitutionId: '',
				anchorAccount: '',
				anchorName: '',
				remark: '',
			};
			this.$refs.ruleForm.resetFields();
			this.dialogVisible = false;
		},
		submit: throttle(function () {
			this.$refs.ruleForm.validate(async valid => {
				if (!valid) return;
				const { form } = this;
				await institutionAddAnchorKs(form);
				this.$message.success('添加成功');
				this.$emit('getList');
				this.handleClose();
			});
		}, 1000),
	},
};
</script>

<style lang="less" scoped>
.label {
	font-size: 16px;
	color: #1d1f23;
	line-height: 20px;
	height: 20px;
	border-left: 4px solid @color-primary;
	padding-left: 8px;
	margin-bottom: 16px;
}
.add-partner {
	line-height: 13px;
	font-size: 13px;
	color: #333;
	.add {
		cursor: pointer;
		color: @color-primary;
	}
}
</style>
